export default __webpack_public_path__ + "static/article-the-ultimate-guide-to-budget-or-spending-ccc99d39c78e57d829def323725338be.jpg";